<label-tag *ngFor="let label of labels$ | async" [label]="label" shortView=1 className="task_preview_label_tags"></label-tag>
